"use client"

import { Badge } from "@/components/ui/badge"
import { Clock, Sparkles } from "lucide-react"
import { getTimeRemaining } from "@/lib/promotions"
import { useEffect, useState } from "react"

interface PromotionBadgeProps {
  badgeText?: string
  showCountdown?: boolean
  endDate?: string
  variant?: "default" | "destructive" | "secondary" | "outline"
}

export function PromotionBadge({
  badgeText,
  showCountdown,
  endDate,
  variant = "default",
}: PromotionBadgeProps) {
  const [timeRemaining, setTimeRemaining] = useState<{
    days: number
    hours: number
    minutes: number
    seconds: number
    isExpired: boolean
  } | null>(null)

  useEffect(() => {
    if (!showCountdown || !endDate) return

    const updateCountdown = () => {
      setTimeRemaining(getTimeRemaining(endDate))
    }

    updateCountdown()
    const interval = setInterval(updateCountdown, 1000)

    return () => clearInterval(interval)
  }, [showCountdown, endDate])

  if (!badgeText && !showCountdown) return null

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {badgeText && (
        <Badge variant={variant} className="text-xs font-semibold px-2 py-1">
          <Sparkles className="h-3 w-3 mr-1" />
          {badgeText}
        </Badge>
      )}
      {showCountdown && timeRemaining && !timeRemaining.isExpired && (
        <Badge variant="outline" className="text-xs font-mono px-2 py-1">
          <Clock className="h-3 w-3 mr-1" />
          {timeRemaining.days > 0 && `${timeRemaining.days}d `}
          {String(timeRemaining.hours).padStart(2, "0")}:
          {String(timeRemaining.minutes).padStart(2, "0")}:
          {String(timeRemaining.seconds).padStart(2, "0")}
        </Badge>
      )}
    </div>
  )
}

